import React from "react";
import { IProps } from "./types";

import messages from '../../dashboard/Meta/General/messages';
import detailsMessages from '../../dashboard/Meta/Details/messages';
import { getIconedDetail, getLabel } from "../Components/IconedDetail";
import { choirDenominationOptions, choirLevelOptions, choirRepertoriNatureOptions, choirStyleOptions } from "../../../consts/meta/general";
import { FormattedMessage, useIntl } from "react-intl";
import Logo from "./Logo";
import { choirFundingModelOptions, choirSizeOptions, choirStatusOptions, choirTypeOptions } from "../../../consts/meta/details";
import { getPhotoURL } from "../../dashboard/Meta/Additional/PhotoGaleryEditor/utils";
import { ChoirName, Column, Container, CoverImage, FoundedDate, MobileApply, Padding, StatusFlag, TitleRow, TopRow, TopRowLeft, TopRowRight } from "./styles";
import { EChoirStatus, EChoirType } from "../../../../../common/types/choir/meta/details";
import WanterVoices from "./WanterVoices";
import { FormElement, Label } from "../../../../components/Form";
import RehearsalTimes from "./RehearsalTimes";
import Venue from "./Venue";
import SocialLinks from "./SocialLinks";
import localMessages from "./messages";

const General = ({ choir, scrollToApply }: IProps) => {
    const { formatMessage, formatDate } = useIntl();
    const { general, details, additional } = choir.meta;
    const statusMessage = getLabel(choirStatusOptions, details.status);
    const statusFlag = !!statusMessage && <StatusFlag>{formatMessage(statusMessage)}</StatusFlag>
    const choirName = <ChoirName>{choir.name}</ChoirName>;
    const description = general.description && <p>{general.description}</p>;
    const coverImageUrl = getPhotoURL(additional.photos[0]);
    const logo = <Logo choir={choir} />;
    const foundedStartText = details.status === EChoirStatus.FORMING ? detailsMessages.startDateFuture : detailsMessages.startDate;
    const foundedDate = details.startDate && <FoundedDate>{formatMessage(foundedStartText)}: {formatDate(details.startDate, { year: 'numeric', month: 'long' })}</FoundedDate>;
    const level = getIconedDetail(messages.level, getLabel(choirLevelOptions, general.level), "choir-level");
    const ageRange = getIconedDetail(detailsMessages.ageRange, `${details.ageRange[0]}-${details.ageRange[1] === 100 ? '∞' : details.ageRange[1]}`, "user")
    const repertoireNature = getIconedDetail(messages.repertoireNature, getLabel(choirRepertoriNatureOptions, general.repertoirNature), "choir-repertoire-nature");
    const denomination = general.denomination && getIconedDetail(messages.denomination, getLabel(choirDenominationOptions, general.denomination), "choir-denomination");
    const style = getIconedDetail(messages.style, getLabel(choirStyleOptions, general.style), "choir-style");
    let typeIcon = 'choir-type-mixed';
    if (details.choirType === EChoirType.MENS) {
        typeIcon = 'choir-type-male';
    } else if (details.choirType === EChoirType.WOMENS) {
        typeIcon = 'choir-type-female';
    }
    const type = getIconedDetail(detailsMessages.choirType, getLabel(choirTypeOptions, details.choirType), typeIcon);
    const size = getIconedDetail(detailsMessages.choirSize, getLabel(choirSizeOptions, details.choirSize), "groups");
    const fundingModel = getIconedDetail(detailsMessages.fundingModel, getLabel(choirFundingModelOptions, details.fundingModel), "donate");
    const wanterVoices = <WanterVoices voices={general.wantedVoices} />
    const repertoirSample = details.repertoirSample && <FormElement>
        <Label>{formatMessage(detailsMessages.repertoirSample)}</Label>
        {details.repertoirSample.split("\n").slice(0, 9).map((line, i) => <div key={i}>{line}</div>)}
    </FormElement>

    const venue = <Venue location={general.rehearsalLocation} />

    const rehearsalTimes = <RehearsalTimes rehearsals={details.rehearsals} />
    const socialLinks = <SocialLinks website={additional.website} socialPages={additional.socialPages} />
    return (
        <Container>
            <CoverImage style={{ backgroundImage: `url(${coverImageUrl})` }} />
            {logo}
            <TopRow hasLogo={!!choir.meta.additional.logo}>
                <TopRowLeft>
                    <TitleRow>
                        {choirName}
                        {statusFlag}
                    </TitleRow>
                    {foundedDate}
                </TopRowLeft>
                <TopRowRight>
                    <button className="button" onClick={scrollToApply}><FormattedMessage {...localMessages.apply}/></button>
                </TopRowRight>
            </TopRow>
            <Padding>
                <Column style={{ flex: 3}}>
                    {wanterVoices}
                    <MobileApply>
                        <button className="button" onClick={scrollToApply}><FormattedMessage {...localMessages.apply}/></button>
                    </MobileApply>
                    {description}

                    {type}
                    {ageRange}
                    {size}
                    {level}
                    {fundingModel}
                    {repertoireNature}
                    {denomination}
                    {style}
                </Column>

                <Column style={{ flex: 2 }}>
                    {repertoirSample}

                    {rehearsalTimes}
                    {venue}
                    {socialLinks}
                </Column>
            </Padding>
        </Container>
    );
};

export default General;
